import { configureStore } from '@reduxjs/toolkit';
import Entities from './entities.state';

export default configureStore({
  reducer: {
    entities: Entities
  }
});
